module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Kid From Port Douglas")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#the-kid-from-port-douglas"
    }
  }, [_vm._v("The Kid from Port Douglas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-the-road-to-port-douglas-and-the-iconic-restaurant-on-the-hill"
    }
  }, [_vm._v("Chapter 1: The Road to Port Douglas and the Iconic Restaurant on the Hill")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-the-catalina"
    }
  }, [_vm._v("Chapter 2: The Catalina")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-3-school-days"
    }
  }, [_vm._v("Chapter 3: School Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-4-our-unique-little-family"
    }
  }, [_vm._v("Chapter 4: Our Unique Little Family")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-5-the-port-douglas-penny-family-saga",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Port Douglas Penny Family Saga")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-6-mother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Mother")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-7-the-court-house-hotel-and-the-characters-therein",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: The Court House Hotel and the Characters Therein")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-8-places-in-and-out-of-the-sun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: ‘Places’ – In and Out of the Sun")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-9-father",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Father")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-10-the-belle-of-the-ball",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: ‘The Belle of the Ball’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-11-she-joined-the-navy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: ‘She Joined the Navy’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-12-the-big-overseas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: The ‘Big Overseas’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-13-the-culture-collision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Culture Collision")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-14-back-home-with-the-folks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: …Back Home with the Folks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-15-port-douglas-revisited",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Port Douglas Revisited")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-16-maweeba-maweeba",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Maweeba, Maweeba")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-17-the-scottish-patient",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: The Scottish Patient")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-18-the-united-kingdom-revisited",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The United Kingdom Revisited")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-19-the-seaside-landlady",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: The Seaside Landlady")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-20-...at-last-were-film-stars",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: ...At Last, We’re Film Stars")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-21-philosophically-speaking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: …Philosophically Speaking")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#the-conclusion-to-a-perfectly-ridiculous-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Conclusion to a Perfectly Ridiculous Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#philosophically-speaking-a-sonnet-to-myself",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophically Speaking… A Sonnet to Myself")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#in-conclusion-my-baby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Conclusion, My Baby")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0